/**
 * @generated SignedSource<<f58b1266f4b615e820f07eb430eac19a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftDraftItemTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftDraftItemTileDetails_viewer">;
  readonly " $fragmentType": "NftDraftItemTile_viewer";
};
export type NftDraftItemTile_viewer$key = {
  readonly " $data"?: NftDraftItemTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftDraftItemTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftDraftItemTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftDraftItemTileDetails_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "016f2aaca71fdac3e6519d4c6c06a771";

export default node;
